// 広告流入元の引き継ぎ
// LP着地時のURLパラメータ(utm_* / gclid / fbclid)を保存し、購入ボタン(.wlp-buy)のリンクに
// 注文属性(attributes[...])として付け足す。注文管理画面の「追加の詳細」と注文CSVの Note Attributes に残る。
(function () {
	var STORAGE_KEY = 'wlp_attribution';
	var TTL = 30 * 24 * 60 * 60 * 1000; // 30日
	var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];

	function readQuery() {
		var found = {};
		var hit = false;
		var pairs = window.location.search.replace(/^\?/, '').split('&');
		for (var i = 0; i < pairs.length; i++) {
			if (!pairs[i]) continue;
			var kv = pairs[i].split('=');
			var key = decodeURIComponent(kv[0]);
			if (PARAMS.indexOf(key) === -1) continue;
			var value = decodeURIComponent((kv[1] || '').replace(/\+/g, ' '));
			if (value) {
				found[key] = value;
				hit = true;
			}
		}
		return hit ? found : null;
	}

	function load() {
		try {
			var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
			if (saved && saved.expires > new Date().getTime()) return saved.data;
		} catch (e) {}
		return null;
	}

	function save(data) {
		try {
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
				data: data,
				expires: new Date().getTime() + TTL
			}));
		} catch (e) {}
	}

	// 新しい広告パラメータ付きで着地したら上書き(ラストタッチ)。無ければ保存済みのものを使う
	var data = readQuery();
	if (data) {
		data.wlp_landing = window.location.pathname;
		data.wlp_landed_at = new Date().toISOString();
		save(data);
	} else {
		data = load();
	}

	function decorate() {
		if (!data) return;
		var query = [];
		for (var key in data) {
			if (data.hasOwnProperty(key)) {
				query.push('attributes[' + key + ']=' + encodeURIComponent(data[key]));
			}
		}
		if (!query.length) return;
		var links = document.querySelectorAll('a.wlp-buy');
		for (var i = 0; i < links.length; i++) {
			var href = links[i].getAttribute('href');
			if (!href || href === '#') continue;
			links[i].setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + query.join('&'));
		}
	}

	// GA4の識別子を注文に持ち越す
	// カスタムピクセル(購入完了)はサンドボックス内で動き、LPのCookieを読めない。
	// そのためクリック時点のCookieから client_id / session_id を読み、注文属性として渡す。
	// これが無いと、購入がLPのセッションと別人・別セッション扱いになる。
	var GA_MEASUREMENT_ID = 'G-3XHNC79HYD';

	function gaIdentifiers() {
		var found = {};
		var client = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.([\d.]+)/);
		if (client) found.ga_client_id = client[1];
		var name = '_ga_' + GA_MEASUREMENT_ID.replace(/^G-/, '');
		var raw = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
		if (raw) {
			// GS1.1.<session_id>.… / GS2.1.s<session_id>$o… の両方に対応
			var parts = raw[1].split('.');
			if (parts[2]) {
				var id = parts[2].split('$')[0].replace(/^s/, '');
				if (/^\d+$/.test(id)) found.ga_session_id = id;
			}
		}
		return found;
	}

	function appendGaIdentifiers(link) {
		var href = link.getAttribute('href');
		if (!href || href === '#' || href.indexOf('attributes[ga_client_id]') !== -1) return;
		var ids = gaIdentifiers();
		var query = [];
		for (var key in ids) {
			if (ids.hasOwnProperty(key)) {
				query.push('attributes[' + key + ']=' + encodeURIComponent(ids[key]));
			}
		}
		if (!query.length) return;
		link.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + query.join('&'));
	}

	function watchBuyLinks() {
		var links = document.querySelectorAll('a.wlp-buy');
		for (var i = 0; i < links.length; i++) {
			// クリックの直前に付ける(読み込み時点ではGA4のCookieがまだ無いことがあるため)
			links[i].addEventListener('pointerdown', function () { appendGaIdentifiers(this); });
			links[i].addEventListener('click', function () { appendGaIdentifiers(this); });
		}
	}

	function init() {
		decorate();
		watchBuyLinks();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();



jQuery(function($){
	$(document).ready(function(){



		// ページトップ
		var showFlug = false;
		var topBtn = $('#pagetop');
		topBtn.css('bottom', '-6em');
		var showFlug = false;
		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				if (showFlug == false) {
					showFlug = true;
					topBtn.stop().animate({'bottom' : '6em'}, 500);
				}
			} else {
				if (showFlug) {
					showFlug = false;
					topBtn.stop().animate({'bottom' : '-6em'}, 200);
				}
			}
		});

		//スクロールしてトップ
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});



		// アンカーリンクスムーズスクロール
		// #で始まるアンカーをクリックした場合に処理
		// https://kaiteki-chokin.com/anchor-link-lazy-loading/
		// https://teratail.com/questions/274473
		$('[href^="#"]').click(function(e) {
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;

			$.when(
				$("html, body").animate({
					scrollTop: position
				}, 500, "swing"),
				e.preventDefault(),
			).done(function() {
				var diff = target.offset().top;
				if (diff === position) {
				} else {
					$("html, body").animate({
						scrollTop: diff
					}, 10, "swing");
				}
			});
		});



	});
});
